import Vue from 'vue'
import Vuex from 'vuex'   

 
Vue.use(Vuex) 

const modules = { 
}

const state = {
    layout: 'LayoutExterno1',
    registro : null

}
const mutations = {
    SET_LAYOUT (state, newLayout) { state.layout = newLayout },
    SET_REGISTRO(state, payload) { state.registro = payload }
}


 

const actions = {

    async setRegistro(state, registro) 
    {   
        state.commit('SET_REGISTRO', registro)    
    
    }
}

export default new Vuex.Store({
    state,
    mutations,
    modules,
    actions
}
)